import React from "react";

const InstagramIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#FFF"
        d="M12 .5c3.176 0 6.05 1.287 8.132 3.368A11.464 11.464 0 0 1 23.5 12c0 3.176-1.287 6.05-3.368 8.132A11.464 11.464 0 0 1 12 23.5c-3.176 0-6.05-1.287-8.132-3.368A11.464 11.464 0 0 1 .5 12c0-3.176 1.287-6.05 3.368-8.132A11.464 11.464 0 0 1 12 .5Z"
      />
      <g fill="#FFF" fillRule="nonzero">
        <path d="M13.01 10.696a1.631 1.631 0 1 1-2.307 2.307 1.631 1.631 0 0 1 2.307-2.307" />
        <path d="M13.76 7.5H9.954a2.45 2.45 0 0 0-2.447 2.447v3.806A2.45 2.45 0 0 0 9.954 16.2h3.806a2.45 2.45 0 0 0 2.447-2.447V9.947A2.45 2.45 0 0 0 13.76 7.5Zm-1.903 6.525c-1.2 0-2.175-.975-2.175-2.175 0-1.2.976-2.175 2.175-2.175 1.2 0 2.175.975 2.175 2.175 0 1.2-.976 2.175-2.175 2.175Zm2.447-4.35a.272.272 0 1 1 0-.544.272.272 0 0 1 0 .544Z" />
      </g>
    </g>
  </svg>
);

export default InstagramIcon;
